import CashierServiceCollection from "../CashierServiceCollection";
import InvoiceModel from "../../models/cashier/InvoiceModel";

export default class InvoiceCollection extends CashierServiceCollection {

  model() {
    return InvoiceModel;
  }

}
